/**
 * @class ColorInFandeck
 */
export default class ColorInFandeck {
    /**
     * @param {Number} id
     * @param {Object} color
     * @param {Object} fandeck
     */
    constructor(id, color, fandeck) {
        this._id = id;
        this._color = color;
        this._fandeck = fandeck;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - ColorInFandeck");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {Object}
     */
    get color() {
        return this._color;
    }

    /**
     * @param {Object} color
     */
    set color(color) {
        this._color = color;
    }

    /**
     * @return {Object}
     */
    get fandeck() {
        return this._fandeck;
    }

    /**
     * @param {Object} fandeck
     */
    set fandeck(fandeck) {
        this._fandeck = fandeck;
    }
}
